import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import QrCodePayDialog from "./QrCodePayDialog";

const QrCodePay = ({ user, currency }) => {
  const history = useHistory();
  const [visible, setVisible] = useState(true);

  return (
    <QrCodePayDialog
      visible={visible}
      onHide={() => {
        setVisible(false);
        history.push("/dashboard");
      }}
      user={user}
      currency={currency}
    />
  );
};

export default QrCodePay;
